"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var inject_typesafe_react_1 = require("inject-typesafe-react");
/**
 * Use state stored in the redux cache via CacheService.
 * @param id
 */
function useCache(key) {
    var cacheService = inject_typesafe_react_1.useServices(function (services) { return services.cacheService(); });
    var setState = React.useCallback(function (value, options) {
        cacheService.storeInCache(key, value, options);
    }, [cacheService, key]);
    return [cacheService.readFromCache(key), setState];
}
exports.useCache = useCache;
//# sourceMappingURL=useCache.js.map